import React from 'react'

export const RadioSelectedSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12.8235"
        cy="12.076"
        r="11.5"
        transform="rotate(90.3634 12.8235 12.076)"
        stroke={props.stroke ?? '#3E4685'}
      />
      <circle
        cx="12.8234"
        cy="12.0751"
        r="6"
        transform="rotate(90.3634 12.8234 12.0751)"
        fill={props.fill ?? '#3E4685'}
      />
    </svg>
  )
}
